module.exports = __webpack_public_path__ + "img/magnify.8f811eb0.svg";